import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

interface Config extends AxiosRequestConfig {
  method: 'DELETE';
  url: `/exams/${string}/locked-problems`;
}

/**
 * destroys all draft locked exam problems for the given exam
 */
export const destroy = (unsavedExamIdentifier: string): Config => {
  return {
    baseURL: BASE_API,
    method: 'DELETE',
    url: `/exams/${unsavedExamIdentifier}/locked-problems`,
  } as const;
};
